import { defineStore } from 'pinia'

export interface SlideshowState {
  list: Array<any>
}

export const useSlideshowStore = defineStore('slideshow', {
  state: (): SlideshowState => ({
    list: [],
  }),
  getters: {
    getList(): SlideshowState['list'] {
      return this.list
    },
  },
  actions: {
    async setList(data: any[]) {
      this.list = data
    },
  },
})
